import React from 'react';

// Le fichier du logo se trouve dans le dossier public/ : public/logo.png
// (si votre fichier est un .jpg, changez simplement l'extension ci-dessous)
const LOGO_SRC = `${process.env.PUBLIC_URL}/signature.jpg`;

const Logo = ({ className = '', alt = '' }) => (
  <img
    src={LOGO_SRC}
    alt={alt}
    className={`logo ${className}`}
    // Si le fichier est absent, on masque l'image au lieu d'afficher une icône cassée
    onError={(e) => { e.currentTarget.style.display = 'none'; }}
  />
);

export default Logo;
